import { Box, Button, ButtonAppearance, ButtonSize, Modal, ModalHeader, ModalSize, TextArea } from '@bechtel/gds';
import styled, { css } from 'styled-components';
export const ModalStyled = styled(Modal).attrs({
  size: ModalSize.DEFAULT,
})`
  width: 40%;
  max-width: 500px;
  height: 40%;
  max-height: 375px;
  transform: translateY(25%);
`;
export const ModalHeaderStyled = styled(ModalHeader)`
  display: flex;
  align-items: center;
  margin: 0;
  ${({ theme }) => css`
    padding: ${theme.spacings[200]};
    height: ${theme.spacings[800]};
  `}
`;
export const TextAreaStyled = styled(TextArea)`
  ${({ theme }) => css`
    padding: ${theme.spacings[400]} ${theme.spacings[500]} ${theme.spacings[500]};
  `}

  ${({ changed }) =>
    changed &&
    css`
      background-color: ${({ theme }) => theme.colors.blue[100]};
    `}
`;
export const ModalFooterStyled = styled(Box).attrs({
  justifyContent: { sm: 'flex-end' },
})`
  background-color: ${({ theme }) => theme.colors.white};
  width: 100%;
`;
export const FooterButtonStyled = styled(Button).attrs({
  appearance: ButtonAppearance.PRIMARY,
  size: ButtonSize.SMALL,
})`
  ${({ theme }) => css`
    min-width: 96px;
    font-weight: ${theme.fontWeights[600]};
    color: ${theme.colors.white};
    padding: ${theme.spacings[500]};
  `}
`;

export const ViewNotesBoxStyled = styled(Box)`
  border: 1px solid ${({ theme }) => theme.colors.blue[200]};
`;
